import { Injectable } from '@angular/core';
import { STORE_KEYS } from '@app/utils/constants';
import { StorageService } from '@shared/services/storage/storage.service';
import { STATES } from '@shared/components/address-list/address-list-form.interface';
import { SalesTaxConfig, SalesTaxMetadata, DatePeriods, DatePeriod, CountrySalesTaxConfig } from '@shared/meta-data';

@Injectable({
  providedIn: 'root'
})
export class TaxConfigStore {

  constructor(private storageService: StorageService) {

  }

  saveSalesTaxConfig(value: SalesTaxConfig, saveObserver = false): SalesTaxConfig {
    return this.storageService.save(STORE_KEYS.SALES_TAX_CONFIG, value, saveObserver)
  }

  retrieveAllTaxConfig(): SalesTaxConfig {
    return this.storageService.get(STORE_KEYS.SALES_TAX_CONFIG)
  }

  retrieveTaxConfigForState(state: STATES) {
    return this.retrieveAllTaxConfig()?.[state] || [];
  }

  saveCountrySalesTaxConfig(value: CountrySalesTaxConfig, saveObserver = false): CountrySalesTaxConfig {
    return this.storageService.save(STORE_KEYS.SALES_TAX_COUNTRY_CONFIG, value, saveObserver);
  }

  retrieveAllCountryTaxConfig(): CountrySalesTaxConfig {
    return this.storageService.get(STORE_KEYS.SALES_TAX_COUNTRY_CONFIG);
  }

  retrieveTaxConfigForCountry(countryCode: string, regionCode?: string) {
    const code = countryCode?.toUpperCase();
    const region = regionCode?.toUpperCase();
    const scheduleKey = region ? `${code}-${region}` : code;
    return this.retrieveAllCountryTaxConfig()?.[scheduleKey] || [];
  }

  saveStateMetadata(value: SalesTaxMetadata, saveObserver = false): SalesTaxMetadata {
    return this.storageService.save(STORE_KEYS.SALES_TAX_METADATA, value, saveObserver)
  }

  retrieveAllStatesMetadata(): SalesTaxMetadata {
    return this.storageService.get(STORE_KEYS.SALES_TAX_METADATA)
  }

  retrieveMetadataForState(state: STATES) {
    return this.retrieveAllStatesMetadata()?.[state] || undefined;
  }

  saveDatePeriods(value: DatePeriods, saveObserver = false): DatePeriods {
    return this.storageService.save(STORE_KEYS.SALES_TAX_DATE_PERIODS, value, saveObserver);
  }

  retrieveAllDatePeriods(): DatePeriods {
    return this.storageService.get(STORE_KEYS.SALES_TAX_DATE_PERIODS);
  }

  retrieveDatePeriodsForSchedule(schedule: string): DatePeriod[] {
    return this.retrieveAllDatePeriods()?.[schedule] || [];
  }
}
